<template>
  <div class="accessory-share">
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
      <el-form-item
          style="float: right; margin-right: 0 "
          v-if="funcView.accessory_cost_share_export"
        >
          <el-button
            class="table-set"
            @click="exportTable('giveawayCostsharePageTotalExport',formSearch)"
          >
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right;">
          <custom-column
           ref="column"
          ></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.goodsName"
            :placeholder="$t('crm_share.pei_jian')"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.afterServiceName"
            :placeholder="$t('crm_share.shou_hou_gong_si')"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <custom-date-picker
            v-model="formSearch.yearMonth"
            type="monthrange"
            range-separator="—"
            value-format="yyyyMM"
            align="right"
            placeholder=""
            :picker-options="pickerOptions"
            prefix-icon="icon icon-calendar"
            :clearable="false"
            :start-placeholder="$t('crm_share.kai_shi_yue')"
            :end-placeholder="$t('crm_share.jie_shu_yue')"
            :default-time="['00:00:00', '23:59:59']"
            style="width: 250px;"
          ></custom-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table
        v-if="funcView.accessory_cost_share_list"
        height="100%"
        :data="tableList"
        :column="tableColumnMonth"
        @filter="filterChange"
        @sort="sortChange"
        :slots="['partSn',...shareYearMonth]"
      >
      <template v-slot:partSn="scope">
          <span>
            {{ scope.row.goodsCode || '-'}}/{{ scope.row.goodsName|| '-'}}
          </span>
        </template>
        <template v-for="item in shareYearMonth" :slot="item" slot-scope="scope">
          {{ scope.row.yearMonthTotalMap[item] }}
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      >
      </custom-page>
    </div>
    <deliver-goods-info-dialog
      v-if="dialogVisible1"
      @close="dialogVisible1 = false"
      :model="dialogModel1"
    ></deliver-goods-info-dialog>
  </div>
</template>

<script>
/** 库存记录 */
import moment from 'moment';
import apis from '@/utils/apis';
import deliverGoodsInfoDialog from '@/pages/crm/components/deliver_goods_info_dialog';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';

export default {
  name: '',
  mixins: [resetFormSearchMixins],
  components: {
    deliverGoodsInfoDialog
  },
  props: {},
  data() {
    return {
      tableCode: 'accessory_share',
      formSearch: {
        pageNum: 1,
        pageSize: 50,
        orderType: '',
        orderBy: '',
        search: '',
        productCode: '',
        deviceBizType: '',
        orgName: '',
        afterServiceName: '',
        goodsName: '',
        yearMonth: [`${moment(this.$getLocalTime()).subtract(6, 'months').add('month').format('YYYYMM')}`, `${moment().add(5, 'months').add('month').format('YYYYMM')}`],
      },
      tableList: [],
      totalRows: null,
      // 发货详情
      dialogVisible1: false,
      dialogModel1: {},
      minDate: null,
      maxDate: null,
      pickerOptions: {
        // 限制最多选12个月
        disabledDate: (time) => {
          if (this.minDate !== null && this.maxDate === null) {
            const minMonth = this.minDate.getMonth(),
              lastYear = new Date(this.minDate).setMonth(minMonth - 11),
              nextYear = new Date(this.minDate).setMonth(minMonth + 11);
            // 只能选 minDate 前后一年的范围
            return time.valueOf() < lastYear.valueOf() || time.valueOf() > nextYear.valueOf();
          }
          return false;
        },
        onPick: ({ minDate, maxDate }) => {
          this.minDate = minDate;
          this.maxDate = maxDate;
        }
      },


    };
  },
  computed: {
    shareYearMonth() {
      let allMonths = [];
      if (this.formSearch.yearMonth.length) {
        allMonths = this.getMonthsInRange(this.formSearch.yearMonth[0], this.formSearch.yearMonth[1]);
      }
      return allMonths;
    },
    tableColumnMonth() {
      let allColumn = this.tableColumn;
      if (this.shareYearMonth && this.shareYearMonth.length) {
        const shareYearMonth = this.shareYearMonth.map(item => ({

          columnName: item,
          columnCode: item,
          selected: true
        }));
        allColumn = [...this.tableColumn, ...shareYearMonth];
      }
      return allColumn;
    }
  },
  watch: {
    shareYearMonth: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getTableList();
        }
      },
    },
  },

  filters: {},
  directives: {},
  methods: {
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    getTableList() {
      this.$getJSON(apis.giveawayCostsharePageTotal, this.formSearch).then((res) => {
        this.tableList = res.data.records;
        this.totalRows = res.data.total;
      });
    },
    // 计算yyyyMM区间
    getMonthsInRange(startDateStr, endDateStr) {
      // 将字符串转换为日期对象
      const startDate = new Date(startDateStr.substr(0, 4), startDateStr.substr(4, 2) - 1, 1);
      const endDate = new Date(endDateStr.substr(0, 4), endDateStr.substr(4, 2) - 1, 1);

      // 创建一个数组来存储结果
      const months = [];

      // 循环添加月份到数组，直到达到结束月份
      const currentMonth = new Date(startDate);
      do {
        // 格式化日期为 YYYYMM
        const monthStr = `${currentMonth.getFullYear()}${(`0${currentMonth.getMonth() + 1}`).slice(-2)}`;
        months.push(monthStr);

        // 设置下一个月
        currentMonth.setMonth(currentMonth.getMonth() + 1);
      } while (currentMonth <= endDate);

      return months;
    }


  },
  created() { },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView();
    this.getTableColumn();


  },
};
</script>

<style lang="scss" scoped>
.accessory-share {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-left: 16px;
  padding-top: 16px;

  .check-detail {
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
